import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import NotificacaoService from "../../service/notificacoes";

const INTERVALO_POLL_MS = 45000;
const COR_PRIMARIA = "#008080";

const Wrap = styled.div`
  position: relative;
  margin-right: 14px;
  font-family: "Roboto", sans-serif;
`;

const BotaoSino = styled.button`
  position: relative;
  background: ${(p) => (p.$aberto ? COR_PRIMARIA : "none")};
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(p) => (p.$aberto ? "8px" : "50%")};
  transition: background 0.15s;
  &:hover { background: ${(p) => (p.$aberto ? COR_PRIMARIA : "rgba(0, 128, 128, 0.1)")}; }
`;

const Badge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #db1212;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
`;

const Painel = styled.div`
  position: absolute;
  top: 44px;
  right: 0;
  width: 430px;
  max-width: calc(100vw - 24px);
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
  z-index: 1200;
  overflow: hidden;

  @media (max-width: 767px) {
    position: fixed;
    top: 80px;
    right: 12px;
    left: 12px;
    width: auto;
  }
`;

const PainelHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px 12px 20px;
  background: ${COR_PRIMARIA};
  color: #fff;
`;

const PainelTitulo = styled.span`
  font-size: 15px;
  font-weight: 700;
`;

const ContadorNaoLidas = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #db1212;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  box-sizing: border-box;
`;

const AcoesHead = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LinkAcao = styled.button`
  border: none;
  background: none;
  color: #fff;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  &:hover { text-decoration: underline; }
`;

const BotaoFechar = styled.button`
  border: none;
  background: none;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  &:hover { background: rgba(255, 255, 255, 0.15); }
`;

const Lista = styled.div`
  max-height: 380px;
  overflow-y: auto;
`;

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: ${(p) => (p.$lida ? "#fff" : "#effafa")};
  border-bottom: 1px solid #e3e3e3;
  padding: 14px 16px 14px 18px;
  cursor: pointer;
  outline: none;
  &:hover { background: ${(p) => (p.$lida ? "#f7fafa" : "#e6f6f6")}; }
  &:focus-visible { box-shadow: inset 0 0 0 2px ${COR_PRIMARIA}; }
`;

const Dot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${(p) => (p.$lida ? "#d0d0d0" : "#00a19a")};
  flex-shrink: 0;
  margin-top: 6px;
`;

const ItemCorpo = styled.div`
  flex: 1;
  min-width: 0;
`;

const ItemTitulo = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${(p) => (p.$lida ? "#666" : COR_PRIMARIA)};
  overflow-wrap: break-word;
  word-break: break-word;
`;

const LinhaMsg = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 3px;
  font-size: 12.5px;
  color: #444;
  line-height: 1.4;
`;

const ItemMsg = styled.div`
  min-width: 0;
  ${(p) =>
    p.$expandida
      ? `
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;
  `
      : `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const VerMais = styled.button`
  border: none;
  background: none;
  padding: 0 0 0 2px;
  font-size: 12.5px;
  font-weight: 700;
  color: #444;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { color: ${COR_PRIMARIA}; text-decoration: underline; }
`;

const VerMenos = styled(VerMais)`
  display: block;
  padding: 2px 0 0;
`;

const ItemMeta = styled.div`
  font-size: 11.5px;
  color: #a0a0a0;
  margin-top: 6px;
`;

const CheckWrap = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: center;
  padding: 4px;
  cursor: pointer;

  input {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    accent-color: ${COR_PRIMARIA};
  }
`;

const PainelFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 18px;
  font-size: 12.5px;
  color: #555;
`;

const LinkRodape = styled.button`
  border: none;
  background: none;
  padding: 12px 0;
  font-size: 12.5px;
  color: ${(p) => (p.$perigo ? "#c62828" : "#555")};
  font-weight: ${(p) => (p.$forte ? 700 : 400)};
  cursor: pointer;
  &:hover:not(:disabled) { text-decoration: underline; }
  &:disabled { opacity: 0.5; cursor: default; }
`;

const AcoesRodape = styled.div`
  margin-left: auto;
  display: flex;
  gap: 14px;
`;

const ErroRodape = styled.span`
  color: #c62828;
`;

const Vazio = styled.div`
  padding: 28px 14px;
  text-align: center;
  color: #999;
  font-size: 13px;
  font-style: italic;
`;

const SinoIcon = ({ ativo, aberto }) => {
  const cor = aberto ? "#fff" : ativo ? COR_PRIMARIA : "#8e8e93";
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 8A6 6 0 0 0 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
        stroke={cor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.73 21A2 2 0 0 1 10.27 21"
        stroke={cor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const FecharIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

// Ex.: "21/07/2026 09:14"
const formatarDataHora = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const data = d.toLocaleDateString("pt-BR");
  const hora = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return `${data} ${hora}`;
};

const ItemNotificacao = ({ n, selecionada, onAlternarSelecao, onLer }) => {
  const [expandida, setExpandida] = useState(false);
  const [truncada, setTruncada] = useState(false);
  const msgRef = useRef(null);

  // Detecta se a mensagem não cabe em uma linha (para exibir "Ver mais")
  useLayoutEffect(() => {
    if (expandida) return;
    const el = msgRef.current;
    if (!el) {
      setTruncada(false);
      return;
    }
    const temQuebra = /\r|\n/.test(n.mensagem || "");
    setTruncada(temQuebra || el.scrollWidth > el.clientWidth + 1);
  }, [n.mensagem, expandida]);

  const verMais = (e) => {
    e.stopPropagation();
    setExpandida(true);
    onLer(n);
  };

  const verMenos = (e) => {
    e.stopPropagation();
    setExpandida(false);
  };

  return (
    <Item
      $lida={n.lida}
      role="button"
      tabIndex={0}
      onClick={() => onLer(n)}
      onKeyDown={(e) => {
        if (e.target !== e.currentTarget) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onLer(n);
        }
      }}
    >
      <Dot $lida={n.lida} />

      <ItemCorpo>
        <ItemTitulo $lida={n.lida}>{n.titulo || "Notificação"}</ItemTitulo>

        {n.mensagem ? (
          <>
            <LinhaMsg>
              <ItemMsg ref={msgRef} $expandida={expandida}>{n.mensagem}</ItemMsg>
              {truncada && !expandida && (
                <VerMais type="button" onClick={verMais}>Ver mais</VerMais>
              )}
            </LinhaMsg>
            {expandida && (
              <VerMenos type="button" onClick={verMenos}>Ver menos</VerMenos>
            )}
          </>
        ) : null}

        <ItemMeta>
          {formatarDataHora(n.createdAt)}
          {n.enviadoPorNome ? ` · ${n.enviadoPorNome}` : ""}
        </ItemMeta>
      </ItemCorpo>

      <CheckWrap onClick={(e) => e.stopPropagation()} title="Selecionar">
        <input
          type="checkbox"
          checked={selecionada}
          onChange={() => onAlternarSelecao(n._id)}
          aria-label={`Selecionar notificação ${n.titulo || ""}`.trim()}
        />
      </CheckWrap>
    </Item>
  );
};

const SinoNotificacoes = () => {
  const [lista, setLista] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [selecionadas, setSelecionadas] = useState([]);
  const [confirmandoApagar, setConfirmandoApagar] = useState(false);
  const [apagando, setApagando] = useState(false);
  const [erroApagar, setErroApagar] = useState("");
  const wrapRef = useRef(null);

  const carregar = useCallback(async () => {
    const dados = await NotificacaoService.listarMinhas();
    setLista(Array.isArray(dados) ? dados : []);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("idUsuario")) return;
    carregar();
    const t = setInterval(carregar, INTERVALO_POLL_MS);
    return () => clearInterval(t);
  }, [carregar]);

  // fecha ao clicar fora ou com Esc
  useEffect(() => {
    if (!aberto) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setAberto(false);
    };
    const onKey = (e) => { if (e.key === "Escape") setAberto(false); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [aberto]);

  // limpa a seleção e a confirmação sempre que o painel fecha
  useEffect(() => {
    if (!aberto) {
      setSelecionadas([]);
      setConfirmandoApagar(false);
      setErroApagar("");
    }
  }, [aberto]);

  const naoLidas = lista.filter((n) => !n.lida).length;
  const visiveis = lista.slice(0, 15);
  const selecionadasVisiveis = visiveis.filter((n) => selecionadas.includes(n._id));
  const selecionadasNaoLidas = selecionadasVisiveis.filter((n) => !n.lida);
  const apagarSoSelecionadas = selecionadasVisiveis.length > 0;

  const abrir = () => {
    const novo = !aberto;
    setAberto(novo);
    if (novo) carregar();
  };

  const marcarLida = async (n) => {
    if (n.lida) return;
    setLista((prev) => prev.map((x) => (x._id === n._id ? { ...x, lida: true } : x)));
    try { await NotificacaoService.marcarComoLida(n._id); } catch (_) {}
  };

  const alternarSelecao = (id) => {
    setConfirmandoApagar(false);
    setErroApagar("");
    setSelecionadas((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  // Apaga as selecionadas (se houver) ou todas. Só somem para o usuário logado.
  const confirmarApagar = async () => {
    const ids = selecionadasVisiveis.map((n) => n._id);
    setApagando(true);
    setErroApagar("");
    try {
      if (ids.length > 0) {
        await NotificacaoService.apagar(ids);
        setLista((prev) => prev.filter((x) => !ids.includes(x._id)));
      } else {
        await NotificacaoService.apagarTodas();
        setLista([]);
      }
      setSelecionadas([]);
      setConfirmandoApagar(false);
    } catch (_) {
      setErroApagar("Não foi possível apagar. Tente novamente.");
    } finally {
      setApagando(false);
    }
  };

  const marcarSelecionadas = async () => {
    const alvos = selecionadasNaoLidas;
    setSelecionadas([]);
    await Promise.all(alvos.map((n) => marcarLida(n)));
  };

  const marcarTodas = async () => {
    setSelecionadas([]);
    setLista((prev) => prev.map((x) => ({ ...x, lida: true })));
    try { await NotificacaoService.marcarTodasComoLidas(); } catch (_) {}
  };

  return (
    <Wrap ref={wrapRef}>
      <BotaoSino type="button" onClick={abrir} aria-label="Notificações" $aberto={aberto}>
        <SinoIcon ativo={naoLidas > 0} aberto={aberto} />
        {naoLidas > 0 && <Badge>{naoLidas > 9 ? "9+" : naoLidas}</Badge>}
      </BotaoSino>

      {aberto && (
        <Painel>
          <PainelHead>
            <PainelTitulo>Notificações</PainelTitulo>
            {naoLidas > 0 && <ContadorNaoLidas>{naoLidas > 99 ? "99+" : naoLidas}</ContadorNaoLidas>}
            <AcoesHead>
              {selecionadasNaoLidas.length > 0 ? (
                <LinkAcao type="button" onClick={marcarSelecionadas}>
                  Marcar selecionadas como lidas
                </LinkAcao>
              ) : naoLidas > 0 ? (
                <LinkAcao type="button" onClick={marcarTodas}>Marcar todas como lidas</LinkAcao>
              ) : null}
              <BotaoFechar type="button" onClick={() => setAberto(false)} aria-label="Fechar notificações">
                <FecharIcon />
              </BotaoFechar>
            </AcoesHead>
          </PainelHead>

          <Lista>
            {visiveis.length === 0 ? (
              <Vazio>Sem notificações.</Vazio>
            ) : (
              visiveis.map((n) => (
                <ItemNotificacao
                  key={n._id}
                  n={n}
                  selecionada={selecionadas.includes(n._id)}
                  onAlternarSelecao={alternarSelecao}
                  onLer={marcarLida}
                />
              ))
            )}
          </Lista>

          {visiveis.length > 0 && (
            <PainelFooter>
              {erroApagar ? (
                <ErroRodape>{erroApagar}</ErroRodape>
              ) : confirmandoApagar ? (
                <span>
                  {apagarSoSelecionadas
                    ? `Apagar ${selecionadasVisiveis.length} selecionada${selecionadasVisiveis.length > 1 ? "s" : ""}?`
                    : "Apagar todas as notificações?"}
                </span>
              ) : (
                <LinkRodape type="button" onClick={() => setConfirmandoApagar(true)}>
                  {apagarSoSelecionadas
                    ? `Apagar selecionadas (${selecionadasVisiveis.length})`
                    : "Apagar todas as notificações"}
                </LinkRodape>
              )}

              {(confirmandoApagar || erroApagar) && (
                <AcoesRodape>
                  <LinkRodape
                    type="button"
                    disabled={apagando}
                    onClick={() => { setConfirmandoApagar(false); setErroApagar(""); }}
                  >
                    Cancelar
                  </LinkRodape>
                  <LinkRodape type="button" $perigo $forte disabled={apagando} onClick={confirmarApagar}>
                    {apagando ? "Apagando..." : erroApagar ? "Tentar novamente" : "Apagar"}
                  </LinkRodape>
                </AcoesRodape>
              )}
            </PainelFooter>
          )}
        </Painel>
      )}
    </Wrap>
  );
};

export default SinoNotificacoes;
